import React, { useState, useEffect } from 'react'
import { Typography } from '@mui/material'
import {
  TourGuide,
  LayoutFooter,
  MuiImage,
} from '../../components'
import { useGlobalStore } from '../../store'
import {
  getImageUrl,
  getLogData,
  timeStampToDate,
} from '../../util'

import {
  OuterWrapper,
  InnerWrapper,
  IconCloseOuterWrapper,
  HeaderRightSection,
  HeaderLeftSection,
  Logo,
} from './style'

const AskIaLayout = ({children, actionButtons}) => {
  const {
    isTourGuideActive,
    theme,
    company,
    projectIdValue,
  } = useGlobalStore()

  const logoFolder = theme === 'dark' ? 'logos/theme-dark' : 'logos/default'
  const logoPath = getImageUrl(logoFolder, company?.CompanyLogo, 'svg')
  const [headerData, setHeaderData] = useState({})

  useEffect(() => {
    getHeaderInfo()
  }, [])

  const getHeaderInfo = () => {
    const headerLogData = projectIdValue.ProjectId
      ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
      : {}

    const headerObj = {
      studyId: projectIdValue.StudyId,
      brandName: headerLogData.BrandName || headerLogData?.CategoryName,
      breadCrumb: headerLogData.ProjectType,
      projectType: `${headerLogData.ProjectType}, ${headerLogData.MarketName}`,
      subTitle: projectIdValue.Period,
      lastUpdated: timeStampToDate(projectIdValue.ModifiedDate),
    }
    setHeaderData(headerObj)
  }

  return (
    <OuterWrapper>
      <IconCloseOuterWrapper>
        <HeaderLeftSection>
          <Logo className='brandLogo'>
            <MuiImage src={logoPath} />
          </Logo>
          <Typography sx={{}} className='brand-name'>
            {headerData?.brandName}
          </Typography>
          <Typography sx={{}} className='project-type'>
            {headerData?.projectType}
          </Typography>
          <Typography className='sub-title'>{headerData?.subTitle}</Typography>
        </HeaderLeftSection>
        <HeaderRightSection>
          {actionButtons}
        </HeaderRightSection>
      </IconCloseOuterWrapper>
      <InnerWrapper>
        {children}
      </InnerWrapper>
      <LayoutFooter isThemed />
      {isTourGuideActive && <TourGuide type='askIa' />}
    </OuterWrapper>
  )
}

export default AskIaLayout
